var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-indicator"},[_c('icon',{attrs:{"name":_vm.iconName}}),_c('span',[_vm._v(_vm._s(_vm.label))]),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }